var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96069(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-069-1{fill:#fff;}.cls-96-069-2,.cls-96-069-3{fill:none;}.cls-96-069-2{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-96-069-3{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-069-2",
    x: 30.87,
    y: 50.56,
    width: 16.62,
    height: 27.44,
    rx: 6.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-069-2",
    x1: 30.87,
    y1: 59.59,
    x2: 47.49,
    y2: 59.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-069-2",
    x1: 36,
    y1: 51.78,
    x2: 36,
    y2: 59.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-069-2",
    x1: 42.36,
    y1: 51.78,
    x2: 42.36,
    y2: 59.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-069-2",
    d: "M10,48.19c-5.91,17.1,10,21.6,10,14C19.6,54,4.06,60.13,11.84,74.75,19.5,89.14,37.1,85.17,39.18,78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-069-2",
    x1: 58.28,
    y1: 38.85,
    x2: 58.28,
    y2: 23.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-96-069-2",
    x1: 64.02,
    y1: 23.58,
    x2: 64.02,
    y2: 38.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-069-2",
    d: "M65.21,84.47H57.09a1.36,1.36,0,0,1-1.36-1.41L57,40.21a1.36,1.36,0,0,1,1.36-1.32H64a1.36,1.36,0,0,1,1.36,1.32l1.22,42.85A1.37,1.37,0,0,1,65.21,84.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-069-2",
    d: "M67.38,11.53H54.92a.92.92,0,0,0-.92.92v1.48H48.55V12.45a.92.92,0,0,0-.92-.92H43.17a.92.92,0,0,0-.92.92V22.62a.92.92,0,0,0,.92.92h4.46a.92.92,0,0,0,.92-.92V21.14H54v1.48a.92.92,0,0,0,.92.92H67.38a.92.92,0,0,0,.91-.92V21.4a20.31,20.31,0,0,1,19,2.14A22.52,22.52,0,0,0,67.38,11.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-069-2",
    d: "M13.49,20.62H24.65a4.15,4.15,0,0,1,4.15,4.15V35.13a4.15,4.15,0,0,1-4.15,4.15H9.33a0,0,0,0,1,0,0V24.77A4.15,4.15,0,0,1,13.49,20.62Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-96-069-2",
    points: "29.46 34.59 41.03 34.59 41.03 31.63 45.05 31.63 45.05 39.28 23.41 39.28"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96-069-2",
    cx: 19.07,
    cy: 29.95,
    r: 4.43
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96069);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_069.49c02588dcedcedb5db71309c6c49665.svg";
export { ForwardRef as ReactComponent };